import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography , Box, Menu, MenuItem, IconButton } from "@mui/material";
import {Fingerprint , CheckBox , NotInterested , Delete, MoreVert, ExitToApp} from "@mui/icons-material";
import { DataGrid ,GridToolbarContainer, GridToolbarDensitySelector, } from "@mui/x-data-grid";
import { GridToolbarQuickFilter } from '@mui/x-data-grid';
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useSelector , useDispatch } from "react-redux";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import _ from "lodash";

//Services
import DriverApi from "Services/Driver";

//Modals
import DriverAddModal from "Pages/Modals/Driver/Create";
import DriverUpdateModal from "Pages/Modals/Driver/Update";
import DriverDeleteModal from "Pages/Modals/Driver/Delete";

const Driver = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );
  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );
  const subcmpnyName = useSelector(
      (state) => state?.AuthReducer?.subCmpny || ""
    );
  const [searchText, setSearchText] = useState("");
  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);   
const [driverId, setDriverId] = useState("");
  const [drivermodelId, setDrivermodelId] = useState("");

  // Menu state for dropdown
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentDriver, setCurrentDriver] = useState(null);

  // Handle menu open
  const handleMenuOpen = (event, driverRow) => {
    setAnchorEl(event.currentTarget);
    setCurrentDriver(driverRow);
  };

  // Handle menu close
  const handleMenuClose = () => {
    setAnchorEl(null);
    setCurrentDriver(null);
  };

  // Handle sign out driver
  const handleSignOutDriver = () => {
    if (currentDriver) {
      // Pass the drivermodel ID to the sign out API
      const drivermodelId = currentDriver?._id;
      console.log(drivermodelId)
      dispatch(showLoader("Signing out driver..."));
      const onSuccess = (res) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Driver signed out successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        handleMenuClose();
        getDrivers();
      };
      const onFailure = (err) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: err?.response?.data?.message || "Failed to sign out driver",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "error",
          })
        );
        handleMenuClose();
      };
      DriverApi.signOutDriver(drivermodelId, {userId:drivermodelId}).then(onSuccess, onFailure);
    }
  };

  // Handle delete driver from menu
  const handleDeleteFromMenu = () => {
    if (currentDriver) {
      handleOpenDeleteDriverModal(currentDriver);
    }
    handleMenuClose();
  };

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(10); // Initial page size
  const [totalPages, setTotalPages] = useState(1);

  /**
   * Modals
   */

  // Driver add modal

  const [addDriverModal, setAddDriverModal] = useState(false);

  const handleOpenAddDriverModal = () => {
    setAddDriverModal(true);
  };

  const handleCloseAddDriverModal = () => {
    setAddDriverModal(false);
    getDrivers();
  };

  // Driver update modal

  const [updateDriverModal, setDriverUpdateModal] = useState(false);

  const handleOpenUpdateDriverModal = (row) => {
    setDriverId(row?._id);
    setDriverUpdateModal(true);
  };

  const handleCloseUpdateDriverModal = () => {
    setDriverUpdateModal(false);
    getDrivers();
  };

  // Driver update modal

  const [DeleteDriverModal, setDriverDeleteModal] = useState(false);

  const handleOpenDeleteDriverModal = (row) => {
    //console.log('row--->',row);
    setDriverId(row?._id);
    setDrivermodelId(row?.driver_ride_details?._id);
    setDriverDeleteModal(true);
  };

  const handleCloseDeleteDriverModal = () => {
    setDriverDeleteModal(false);
    getDrivers();
  };
  
  // Get Drivers list api

  const getDrivers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        //console.log('drivers-->',res?.data?.data?.data);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    const params = { page, limit: pageSize, search: searchText };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    DriverApi.getDriverList(params).then(
      onSuccess,
      onFailure
    );
  }, [page, pageSize, searchText, demoaccount_id]);


  const getAllDrivers = useCallback(() => {
  //  dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    DriverApi.getDriverList({ page:1, limit: "unlimited" , search: ""}).then(
      onSuccess,
      onFailure
    );
  }, [demoaccount_id]);

  useEffect(() => {
    getDrivers();
    getAllDrivers();
  }, [getDrivers, getAllDrivers]);

  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All DriverList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const handleCopy = () => {
    // Define column widths
    const columnWidths = [5, 15, 25, 15, 15, 15, 15, 15]; // Adjust widths as needed
  
    // Helper function to pad text to the desired width
    const padText = (text, width) => {
      return (text ?? "").toString().padEnd(width, " ");
    };
    // Create table header
    const header = [
      padText("S.NO", columnWidths[0]),
      padText("User Name", columnWidths[1]),
      padText("Email", columnWidths[2]),
      padText("Mobile", columnWidths[3]),
      padText("Total Requests", columnWidths[4]),
      padText("Accepted Requests", columnWidths[5]),
      padText("Cancelled Requests", columnWidths[6]),
      padText("Account Status", columnWidths[7]),
    ].join("");
  
    // Create table rows
    const rows = dataRows
      .map((row) =>
        [
          padText(row.sno, columnWidths[0]),
          padText(row.userName, columnWidths[1]),
          padText(row.email, columnWidths[2]),
          padText(row.mobile, columnWidths[3]),
          padText(row.total_requests, columnWidths[4]),
          padText(row.accepted_requests, columnWidths[5]),
          padText(row.cancelled_requests, columnWidths[6]),
          padText(row.accountStatus, columnWidths[7]),
        ].join("")
      )
      .join("\n");
  
    // Combine header and rows
    const formattedContent = [header, rows].join("\n");
  
    // Copy to clipboard
    navigator.clipboard.writeText(formattedContent).then(() => {
      alert("Table copied to clipboard!");
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "DriverList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "DriverList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,row.userName,row.email,
     row.mobile,row.total_requests,row.accepted_requests,
  row.cancelled_requests,row.accountStatus,
         
]);
    doc.autoTable({
head: [["S.NO","User Name","Email","Mobile","Total requests","Accepted requests","Cancelled requests","Account status"]],
body: tableData,
    });
    doc.save("DriverList.pdf");
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };


  function CustomToolbar() {
    return (
<Box sx={{ p: 1, pb: 0, display: "flex", justifyContent: "flex-start" }}>
<GridToolbarQuickFilter debounceMs={800} autoFocus/>
<GridToolbarContainer>
<GridToolbarDensitySelector />
</GridToolbarContainer>
</Box>
    );
  }

  const filteredRows = (row || []).filter((data) => {
    // console.log('userType--->',userType)
    // console.log('subcmpnyName--->',subcmpnyName)
    if (userType === "SUB COMPANY" && subcmpnyName) {
      console.log(data);
      
      return data?.sub_companyName === subcmpnyName;
    }
    return true; // For other user types, include all
  });

  const dataRows = filteredRows.map((data, index) => ({
    sno: calculateSno(page, pageSize, index),
    userName: data?.firstName+" "+data?.lastName,
    email: data?.email,
    mobile: data?.countryCode+" "+data?.mobileNumber,
    total_requests: data?.driver_ride_details?.total_requests?.length,
    accepted_requests: data?.driver_ride_details?.accepted_requests?.length,
    cancelled_requests: data?.driver_ride_details?.cancelled_requests?.length,
    accountStatus:data?.driver_ride_details?.accountStatus,
    row: data, 
  }));

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      minWidth: 10, // Minimum column width
      resizable: true, // Allow users to resize
        sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "userName",
      headerName: "User Name",
      minWidth: 150, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.userName}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 200, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.email}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "mobile",
      headerName: "Mobile",
      minWidth: 150, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.mobile}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "total_requests",
      headerName: "Total requests",
      minWidth: 120, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <Typography variant="body2">{params?.row?.total_requests}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "cancelled_requests",
      headerName: "Cancelled requests",
      minWidth: 155, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <Typography variant="body2">{params?.row?.cancelled_requests}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "accepted_requests",
      headerName: "Accepted Requests",
      minWidth: 145, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <Typography variant="body2">{params?.row?.accepted_requests}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "actions",
      headerName: "Documents / Service Type",
      minWidth: 200, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
      const { accountStatus } = params.row; 

       return (
       <>
<div className={classes.iconsWrapper}>
  {accountStatus === "APPROVED" ? (
    <section className={classes.editIcon}>
      <Button
        variant="contained"
        color="success"
        className={classes.approvedText}
        startIcon={<CheckBox />}
        onClick={() => handleOpenUpdateDriverModal(params?.row?.row)}
      >
        APPROVED
      </Button>
    </section>
  ) : accountStatus === "BANNED" ? (
    <section className={classes.editIcon}>
      <Button
        variant="contained"
        color="error"
        className={classes.bannedText}
        startIcon={<NotInterested />}
        onClick={() => handleOpenUpdateDriverModal(params?.row?.row)}
      >
        BANNED
      </Button>
    </section>
  ) : (
    <section className={classes.editIcon}>
      <Button
        variant="contained"
        color="secondary"
        className={classes.defaultText}
        startIcon={<Fingerprint />}
        onClick={() => handleOpenUpdateDriverModal(params?.row?.row)}
      >
        {accountStatus || "ONBOARDING"}
      </Button>
    </section>
  )}
</div>
</>
        );
      },
    },
    {
      field: "delete",
      headerName: "Actions",
      minWidth: 50, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
       return (
       <>
        <IconButton
          variant="contained"
          color="error"
          style={{ minWidth: "36px", padding: "6px", backgroundColor: "#e5393526" }}
          onClick={(event) => handleMenuOpen(event, params?.row?.row)}
        >
          <MoreVert />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl) && currentDriver?._id === params?.row?.row?._id}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleDeleteFromMenu}>
            <Delete style={{ marginRight: 8 }} /> Delete
          </MenuItem>
          <MenuItem onClick={handleSignOutDriver}>
            <ExitToApp style={{ marginRight: 8 }} /> Sign Out
          </MenuItem>
        </Menu>
</>

        );
      },
    },
  ];

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "User Name":row.userName,
    "Email":row.email,
    "Mobile": row.mobile,
    "Total requests": row.total_requests,
    "Accepted requests": row.accepted_requests,
    "Cancelled requests": row.cancelled_requests,
    "Account status": row.accountStatus,
  }));

  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
   sno: calculateSno(page, pageSize, index),
    userName: data?.firstName+" "+data?.lastName,
    email: data?.email,
    mobile: data?.countryCode+" "+data?.mobileNumber,
    total_requests: data?.driver_ride_details?.total_requests?.length,
    accepted_requests: data?.driver_ride_details?.accepted_requests?.length,
    cancelled_requests: data?.driver_ride_details?.cancelled_requests?.length,
    accountStatus:data?.driver_ride_details?.accountStatus,
    row: data, 
  }));  
  
  const bulkformatteddatas = bulkdataRows.map((row) => ({
   "S.NO": row.sno,
    "User Name":row.userName,
    "Email":row.email,
    "Mobile": row.mobile,
    "Total requests": row.total_requests,
    "Accepted requests": row.accepted_requests,
    "Cancelled requests": row.cancelled_requests,
    "Account status": row.accountStatus,
  }));  

  return (
    <>
      <Grid container className={classes.root}>

<Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" onClick={handleCopy}>
      COPY
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" onClick={handleDownloadExcel}>
      EXCEL
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" onClick={handleDownloadCSV}>
      CSV
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" onClick={handleDownloadPDF}>
      PDF
    </Button>
  </Grid>
      <Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
      <Button variant="contained" onClick={handleDownloadAll}>
      Download ALL
      </Button>
      </Grid>      
  <Grid item xs={6} md={6} lg={6} xl={6} className={classes.addBtn}>
    <Button variant="contained" onClick={handleOpenAddDriverModal}>
      Add Driver
    </Button>
  </Grid>

  <Grid item xs={12}>
    <section className={classes.dataGridTable}>
      <DataGrid
        getRowId={(row) => row?.row?._id}
        rows={dataRows}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => {
          setPageSize(newPageSize);
          setPage(1);
        }}
        onPageChange={(newPage) => handlePageChange(newPage)}
        rowsPerPageOptions={[5, 10, 25, 50]}
        pagination
        autoHeight={true}
        disableSelectionOnClick
        scrollbarSize={4}
        rowHeight={70}
        style={{ padding: "10px", borderRadius: "0px", overflowX: "auto" }}
        paginationMode="server" 
        rowCount={totalPages}
        filterMode="server"
        onFilterModelChange={(model) => {
        const value = model?.quickFilterValues?.join(" ") || "";
       // console.log(value);
        setSearchText(value);          
        }}        
        density="compact"
        components={{
          Toolbar:CustomToolbar,
        }}
      />
    </section>
  </Grid>

      </Grid>
      <DriverAddModal
        openDialog={addDriverModal}
        handleClose={handleCloseAddDriverModal}
      ></DriverAddModal>
      <DriverUpdateModal
        openDialog={updateDriverModal}
        handleClose={handleCloseUpdateDriverModal}
        driverId={driverId}
      ></DriverUpdateModal>
        <DriverDeleteModal
        openDialog={DeleteDriverModal}
        handleClose={handleCloseDeleteDriverModal}
        driverId={driverId}
        drivermodelId={drivermodelId}
      ></DriverDeleteModal>
    </>
  );
};

export default Driver;
